<div class="modal-header">
  <h4 class="modal-title">Cancellation Discount Offer Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body climber-app-preview">
  <div class="container position-relative mb-4" style="max-width: 700px">

    <div class="row mt-2">
      <div class="col">

        <img [src]="orgConfig.logo_image ? orgConfig.logo_image : '/assets/images/capitan-climbing-and-fitness-logo.png'"
             [height]="orgConfig.logo_height_px"
             [ngStyle]="orgConfig.getClimberAppLogoStyle()"
             alt="org logo" style="display: block;margin: auto">

      </div>
    </div>

    <div class="card capitan-card" [ngStyle]="orgConfig.getClimberAppCapitanCardStyle()">
      <div class="card-header text-center" [ngStyle]="orgConfig.getClimberAppCapitanCardHeaderStyle()">
        Cancel Membership
      </div>
      <div class="card-body">
        <div class="card-item">
          <p class="card-item-main">
            Single Monthly Membership
          </p>
          <p class="card-item-secondary">
            Next bill date: March 1, 2024
          </p>
        </div>
      </div>
    </div>

    <div class="alert alert-success" [innerHTML]="getRenderedMarkdown(customerMessage)">
    </div>

    <p>
      Discount amount: $20.00 (applied on your next bill date, March 1, 2024)
    </p>

    <form action="" method="post" (submit)="$event.preventDefault()">
      <button type="submit" name="apply_cancellation_discount" class="btn btn-primary btn-block mt-3"
              [ngStyle]="orgConfig.getClimberAppCapitanBtnStyle(true)">
        Keep Membership &amp; Apply Discount
      </button>
    </form>

    <hr>

    <p>
      Once you confirm your cancellation, your membership will remain active until your next bill date, March 1, 2024, at which point it will end.
    </p>

    <form action="" method="post" (submit)="$event.preventDefault()">
      <button type="submit" class="btn btn-primary btn-block mt-3"
              [ngStyle]="orgConfig.getClimberAppCapitanBtnStyle(true)">
        Yes, cancel my membership
      </button>
    </form>

    <a href="#" class="btn btn-outline-primary btn-block mt-3"
       [ngStyle]="orgConfig.getClimberAppCapitanBtnStyle(isHoveringBackButton)"
       (mouseenter)="isHoveringBackButton = true"
       (mouseleave)="isHoveringBackButton = false"
       (click)="$event.preventDefault()">
      Back
    </a>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
